var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-text-tabs",style:({
    padding: (_vm.$$FormData.page_edge ) * 0.5 + 'px',
    background: _vm.$$FormData.background_color
  })},[(_vm.$$FormData.tabsList.length)?_c('div',{class:['image-text-tabs__tabs'],style:({
      height: (_vm.$$FormData.height ) * 0.5 + 'px'
    })},[_vm._l((_vm.$$FormData.tabsList),function(item,i){return _c('div',{key:item.__key,ref:"iteRef",refInFor:true,staticClass:"image-text-tabs__tabs-item",style:({
        padding: (_vm.$$FormData.tabs_padding_edge ) * 0.5 + 'px'
      })},[(item.tabs_type === 'image')?_c('div',{staticClass:"image-text-tabs__tabs-image",style:({
          width: (_vm.$$FormData.width ) * 0.5 + 'px',
          height: (_vm.$$FormData.height * _vm.$$FormData.image_scale ) * 0.5 + 'px',
          backgroundImage: `url(${item.tabs_image.src})`
        })}):_vm._e(),(item.tabs_type === 'text')?_c('div',{staticClass:"'image-text-tabs__tabs-text'",style:({
          color: _vm.$$FormData.text_color,
          fontSize: (_vm.$$FormData.title_font_size ) * 0.5 + 'px',
          fontWeight: _vm.current === i ? '600' : _vm.$$FormData.title_font_weight
        })},[_vm._v(_vm._s(item.tabs_name))]):_vm._e()])}),(_vm.$$FormData.tabs_tpl === 'underline')?_c('div',{staticClass:"image-text-tabs__tabs-line",style:({
          width: _vm.lineWidth + 'px',
          height: (_vm.$$FormData.line_height ) * 0.5 + 'px',
          backgroundColor: _vm.$$FormData.line_color,
          left: _vm.lineLeft + 'px',
          transform: `translateX(-${_vm.lineWidth / 2}px)`
        })}):_vm._e(),(_vm.$$FormData.tabs_tpl === 'capsule')?_c('div',{staticClass:"image-text-tabs__tabs-capsule",style:({
          background: _vm.$$FormData.capsule_background_color,
          borderRadius: (_vm.$$FormData.tabs_margin_radius ) * 0.5 + 'px',
          left: _vm.capsuleLeft + 'px',
          width: _vm.currentWidth + 'px',
          height: (_vm.$$FormData.height * _vm.$$FormData.image_scale ) * 0.5 + 'px'
        })}):_vm._e()],2):_c('div',{staticClass:"image-text-tabs__empty"},[_vm._v(" 请添加标签 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }